import React, { useContext } from 'react';
import { FilterBarContext, FilterFieldName } from '../FilterBarContext';
import LabelValuesSelect, { LabelValueOption } from '@/modules/labels/components/LabelValuesSelect';

interface LabelValuesFilterProps {
  filterFieldName: FilterFieldName;
}

const LabelValuesFilter: React.FC<LabelValuesFilterProps> = ({ filterFieldName }) => {
  const { setFilterValue, filterValues } = useContext(FilterBarContext);

  const selectedLabelValues = (filterValues[filterFieldName] as number[]) || [];

  const handleValueChange = (selectedlabels: LabelValueOption[]) => {
    const selectedIds = selectedlabels.map((option) => option.labelValueId);
    const humanValues = selectedlabels.map((option) => `${option.labelName}:${option.labelValueName}`).join(', ');
    const humanValue = humanValues.length > 50 ? `${humanValues.substring(0, 50)}...` : humanValues;
    setFilterValue(filterFieldName, selectedIds, humanValue);
  };

  const handleValueChangeId = (selectedIds: number[]) => {
    //setFilterValue(filterFieldName, selectedIds);
  };

  return <LabelValuesSelect selectedValues={selectedLabelValues} onChange={handleValueChangeId} onChangeLabelName={handleValueChange} />;
};

export default LabelValuesFilter;
